import {
  DeleteOutlined,
  LogoutOutlined,
  PlusSquareOutlined,
  EditOutlined,
  EllipsisOutlined,
  EyeOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import project from "../../assets/img/comman/Group (6).svg";
import {
  Button,
  Card,
  Col,
  Menu,
  Dropdown,
  Input,
  Row,
  Table,
  Typography,
  Image,
  Popconfirm,
  Avatar,
  Select,
  Form,
  Spin,
  Descriptions,
  Modal,
} from "antd";
import React, { useState, Fragment, useEffect, useMemo } from "react";
import { connect } from "react-redux";
import { Link, useParams } from "react-router-dom";
import {
  actionDeleteProject,
  actionGetProjectAll,
  actionGetProjectDetail,
} from "../../store/actions/projectAction";

const { Text } = Typography;
const { Search } = Input;

const Project = (props) => {
  const {
    actionGetProjectAll,
    actionDeleteProject,
    projectsLoader,
    projectsData,
    deleteProjectLoading,
    projectCount,
    actionGetProjectDetail,
    projectDetailLoader,
    projectDetailData,
  } = props;

  const { projectId } = useParams();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = (id) => {
    setIsModalOpen(true);
    actionGetProjectDetail(id);
  };
  const handleOk = (e) => {
    setIsModalOpen(false);
  };
  const handleCancel = (e) => {
    setIsModalOpen(false);
  };

  const projectdata = [
    {
      title: "Project Title",
      description: <>{projectDetailData && projectDetailData.title}</>,
    },
    {
      title: "Description",
      description: <>{projectDetailData && projectDetailData.description}</>,
    },
    // {
    //   title: "Project Agents",
    //   description: (
    //     <>
    //       {projectDetailData &&
    //         projectDetailData.projectagent}
    //     </>
    //   ),
    // },

    // {
    //   title: "Project Users",
    //   description: <><p style={{ textTransform: 'lowercase' }}>{projectDetailData && projectDetailData.projectuser}</p></>,
    // },
  ];

  const [search, setSearch] = useState();
  const [role, setRole] = useState();
  const [data, setData] = useState([]);

  const confirm = (id) => {
    actionDeleteProject(id);
  };

  useEffect(() => {
    actionGetProjectAll(0, 10);
  }, []);

  const columns = [
    {
      title: "Project Title",
      dataIndex: "title",
      key: "title",
      ellipsis: true,
      width: 200,
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      width: 300,
    },
    // {
    //   title: "Project Agents",
    //   dataIndex: "projectagent",
    //   key: "projectagent",
    //   width: 350,
    // },
    // {
    //   title: "Project Users",
    //   dataIndex: "projectuser",
    //   key: "projectuser",
    // },

    {
      title: "Action",
      fixed: "right",
      align: "center",
      width: "80px",
      key: "action",
      render: (item) => (
        <Dropdown
          placement="bottom"
          menu={{
            items: [
              {
                label: (
                  <div>
                    <Link
                      // to={`/view-user/${item._id}`}
                      onClick={(id) => showModal(item.id)}
                      style={{ color: "black" }}
                    >
                      <EyeOutlined
                        style={{
                          color: "#265BA6",
                          fontSize: "18px",
                          marginRight: 10,
                        }}
                      />
                      View
                    </Link>
                  </div>
                ),
              },
              {
                label: (
                  <div>
                    <Link
                      to={`/update-project/${item.id}`}
                      style={{ color: "black" }}
                    >
                      <EditOutlined
                        style={{
                          color: "#265BA6",
                          fontSize: "18px",
                          marginRight: 10,
                        }}
                      />
                      Update
                    </Link>
                  </div>
                ),
              },
              {
                label: (
                  <div>
                    <Image
                      src={project}
                      style={{ marginRight: "10px", width: "20px" }}
                      preview={false}
                    />{" "}
                    Archived
                  </div>
                ),
              },
              // {
              //   label: (
              //     <Popconfirm
              //       okButtonProps={{
              //         loading: deleteProjectLoading,
              //       }}
              //       placement="topLeft"
              //       title="Are you sure to delete this Project?"
              //       onConfirm={() => confirm(item.id)}
              //       okText="Yes"
              //       cancelText="No"
              //     >
              //       <span style={{ color: "black" }}>
              //         <DeleteOutlined
              //           style={{
              //             color: "#265BA6",
              //             fontSize: "18px",
              //             marginRight: 10,
              //           }}
              //         />
              //         Delete
              //       </span>
              //     </Popconfirm>
              //   ),
              // },
              {
                label: (
                  <div>
                    <Image
                      src={project}
                      style={{ marginRight: "10px", width: "20px" }}
                      preview={false}
                    />{" "}
                    Tickets
                  </div>
                ),
              },
            ],
          }}
        >
          <a>
            <EllipsisOutlined style={{ fontSize: "20px" }} />
          </a>
        </Dropdown>
      ),
    },
  ];
  const dataList = [];
  useMemo(() => {
    projectsData &&
      projectsData.map((e, index) => {
        dataList.push({
          key: index,
          id: e.project_id,

          title: <Text strong>{e.title} </Text>,
          description: <Text strong>{e.description}</Text>,
          projectagent:
            e.projectagent && e.projectagent.length > 0 ? (
              <Text strong>
                {e.projectagent.map((data, index) => (
                  <p key={index}>{data.agent_id ? data.agent_id : "-"}</p>
                ))}
              </Text>
            ) : (
              <Text>-</Text>
            ),
          projectuser:
            e.projectuser && e.projectuser.length > 0 ? (
              <Text strong>
                {e.projectuser.map((data, index) => (
                  <p key={index}>
                    {data.project_agent_id ? data.project_agent_id : "-"}
                  </p>
                ))}
              </Text>
            ) : (
              <Text>-</Text>
            ),
        });
      });
    setData(dataList);
  }, [projectsData]);

  const onClickPaginationNumber = (e) => {
    actionGetProjectAll(e.current - 1, e.pageSize);
  };

  const onSearch = (e) => {
    actionGetProjectAll(0, 10, e);
  };

  return (
    <Fragment>
      <Card
        className="main-card no-padding"
        title={
          <>
            <Row align="middle" justify="">
              <Col span={2}>
                <h2 className="text-white text-base">Project</h2>
              </Col>
              <Col span={8}>
                {/* <Input
                  suffix={<SearchOutlined className="site-form-item-icon" />}
                  className="bg-white"
                  placeholder="Search..."
                /> */}
                <Search
                  className="search-input"
                  placeholder="Search..."
                  allowClear
                  enterButton={
                    <SearchOutlined
                      className="site-form-item-icon"
                      style={{
                        color: "white",
                        width: 25,
                        fontSize: 20,
                      }}
                    />
                  }
                  size="large"
                  onSearch={onSearch}
                />
              </Col>
              <Col span={14} align="right">
                <Link to="/create-project">
                  <Button
                    type="primary"
                    className="bg-white-btn"
                    size={"large"}
                  >
                    Create Project
                  </Button>
                </Link>
              </Col>
            </Row>
          </>
        }
        bordered={false}
        style={{
          width: "100%",
        }}
      >
        <Row>
          <Col span={24}>
            <Table
              className="user-table"
              sticky={true}
              size="small"
              pagination={{ total: projectCount, hideOnSinglePage: true }}
              columns={columns}
              dataSource={data}
              loading={projectsLoader}
              onChange={(e) => onClickPaginationNumber(e)}
              scroll={{
                x: 1500,
                y: window.innerWidth < 1500 ? "40vh" : "60vh",
              }}
            />
          </Col>
        </Row>
      </Card>
      <Modal
        style={{ width: 400 }}
        title="View Project"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        // centered
        className="popUp"
      >
        <div className="user-detail">
          <Row gutter={16}>
            <Col span={24}>
              <Descriptions
                title=""
                layout="horizontal"
                colon={true}
                bordered
                column={1}
              >
                {projectdata &&
                  projectdata.length > 0 &&
                  projectdata.map((item, index) => (
                    <Descriptions.Item
                      key={index}
                      label={item.title}
                      style={{
                        background: index % 2 !== 0 ? "#FFFFFF" : "#E2EEFF",
                      }}
                      // Set color dynamically or default to black
                    >
                      {item.description ? item.description : "-"}
                    </Descriptions.Item>
                  ))}
              </Descriptions>
            </Col>
          </Row>
        </div>
      </Modal>
    </Fragment>
  );
};
const mapStateToProps = (state) => {
  return {
    projectsLoader: state.project.projectsLoader,
    projectsData: state.project.projectsData,
    deleteProjectLoading: state.project.deleteProjectLoading,
    projectCount: state.project.projectCount,
    projectDetailLoader: state.project.projectDetailLoader,
    projectDetailData: state.project.projectDetailData,
    projectsCount: state.project.projectsCount,
  };
};

export default connect(mapStateToProps, {
  actionGetProjectAll,
  actionDeleteProject,
  actionGetProjectDetail,
})(Project);
